module.exports = __webpack_public_path__ + "5161a4f724e2a371f2b5c978fd09c03f.pdf";